
import Vue, { PropType } from 'vue'
import {Article} from '@/model/Article'

export default Vue.extend({
  name: 'ArticleCardItem',
  props: {
    item: {
      type: Object as PropType<Article>,
      required: true,
    },
    itemUrlBase: {
      type: String,
      required: true,
    },
  },
  data: () => ({}),
  methods: {
    bookmark: function () {
      if (!this.$store.state.authentication.signedIn) {
        this.$store.dispatch(
          'alert/info',
          'Register new account or sign in order to bookmark articles.'
        )
        return
      }

      this.$api
        .post('/likes/articles/' + this.item.id)
        .then((response: any) => {
          this.item.isFavourite = response.data.isLiked
          const message = response.data.isLiked
            ? 'Article has been added to your favourite articles.'
            : 'Article has been removed from your favourite articles.'
          this.$store.dispatch('alert/success', message)
          if (!response.data.isLiked) {
            this.$emit('bookmarkRemoved', this.item)
          }
        })
    },
  },
})
